import React from "react";

function Header({ heading }) {
  return (
    <header className="header">
      <div className="left-section">
        <button className="menu-toggle" id="menuToggle">
          <i className="fas fa-bars"></i>
        </button>
        <h1 className="page-title">{heading}</h1>
      </div>

      <div className="header-actions">
        <div className="search-bar">
          <i className="fas fa-search search-icon"></i>
          <input type="text" className="search-input" placeholder="Search..." />
        </div>

        <div className="header-icon">
          <i className="fas fa-bell"></i>
          <div className="notification-indicator"></div>
        </div>

        <div className="header-icon">
          <i className="fas fa-envelope"></i>
        </div>
      </div>
    </header>
  );
}

export default Header;
